import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Emphasised = styled.span`
  color: ${props => props.theme.colors.search.hintText};
  font-weight: ${props => props.theme.fontWeights.semibold};
  font-size: ${props => props.theme.fontSizes.md};
  overflow-wrap: break-word;
`

const NoResultsFound = ({ searchTerm }) => (
  <>
    <Emphasised>No results for "{searchTerm}"</Emphasised>. Try a different
    search term.
  </>
)

NoResultsFound.propTypes = {
  searchTerm: PropTypes.string.isRequired
}

export default NoResultsFound
